import React from 'react';

import {
  ClassName,
  IsDisabled,
  IsOptimisticUpdate
} from '../../../../../../../types';

import {
  LifestylesSetSelectedLifestylesID,
  UpdateLifestylesSetCacheAction
} from '../../../../../../lifestylesSets/lifestylesSetsTypes';

import { SelectedLifestylesSidebarAttachModalButtonLifestylesSet } from './SelectedLifestylesSidebarAttachModalButton.types';

import { useSelectedLifestylesSidebarAttachModalButton } from './hooks/useSelectedLifestylesSidebarAttachModalButton';

import { SelectProjectAndTaskModalButton } from '../../../../../../common/components/modalButtons/SelectProjectAndTaskModalButton';

import { words, lifestylesKeys } from '../../../../../../../locales/keys';

interface SelectedLifestylesSidebarAttachModalButtonProps {
  selectedLifestyleIds: LifestylesSetSelectedLifestylesID[];
  optimisticUpdate?: IsOptimisticUpdate;
  onClose: () => void;
  updateLifestylesSetCache: UpdateLifestylesSetCacheAction<SelectedLifestylesSidebarAttachModalButtonLifestylesSet>;
  className: ClassName;
  disabled?: IsDisabled;
}

function SelectedLifestylesSidebarAttachModalButton({
  selectedLifestyleIds,
  optimisticUpdate,
  onClose,
  updateLifestylesSetCache,
  className,
  disabled
}: SelectedLifestylesSidebarAttachModalButtonProps) {
  const { isLoading, errorMessage, handleSubmit, handleClose } =
    useSelectedLifestylesSidebarAttachModalButton({
      selectedLifestyleIds,
      onClose,
      updateLifestylesSetCache
    });

  return (
    <SelectProjectAndTaskModalButton
      className={className}
      dataGa="selected-lifestyles-set-attach-modal-button"
      i18nText={words.attach}
      i18nSubmitText={words.attach}
      i18nTitle={lifestylesKeys.attachSelected}
      isLoading={isLoading}
      submitDisabled={optimisticUpdate}
      errorMessage={errorMessage}
      onClose={handleClose}
      onSubmit={handleSubmit}
      disabled={disabled}
    />
  );
}

export default SelectedLifestylesSidebarAttachModalButton;
